export default {
  namespaced: true,
  state: {
    shareDialogVisible: false
  },
  mutations: {
    SET_SHARE_DIALOG_VISIBLE (state, visible) {
      state.shareDialogVisible = visible
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/share.js